import {Injectable} from '@angular/core';
import {DeviceService} from '@mydocma/core/src/lib/device';
import {isIosDevice} from '@docma-mm-core/utils/utils';
import {getFocusedScroller, isEditableElement, ListenerGroup} from '../shared/keyboard-viewport.util';
import {MmKeyboardDialogAnchorService} from './keyboard-dialog-anchor.service';

const LOCK_DISABLED_SELECTORS = ['.fault-detail-step-content'];

@Injectable({providedIn: 'root'})
export class MmIosKeyboardScrollLockService {

  private listeners = new ListenerGroup();

  constructor(private dialogAnchor: MmKeyboardDialogAnchorService, private deviceService: DeviceService) {}

  init(): void {
    if (this.listeners.active) {
      return;
    }
    if (typeof window === 'undefined' || !window.visualViewport) {
      return;
    }
    const ios = isIosDevice();
    if (!ios && !this.deviceService.isTablet()) {
      return;
    }
    // iOS-only: page-pan pinning + focused-field reveal (Android keyboards don't pan the page)
    if (ios) {
      this.dialogAnchor.start();
    }
    // background scroll-lock while editing: iOS and Android tablets both need it
    this.listeners.add(document, 'touchmove', (event) => this.onTouchMove(event as TouchEvent), {passive: false, capture: true});
  }

  stop(): void {
    this.listeners.clear();
  }

  private onTouchMove(event: TouchEvent): void {
    const active = document.activeElement as HTMLElement | null;
    if (!isEditableElement(active)) {
      return;
    }
    if (!active.closest('.cdk-overlay-pane') && LOCK_DISABLED_SELECTORS.some(selector => active.closest(selector))) {
      return;
    }
    const scroller = getFocusedScroller(active);
    scroller.style.overscrollBehavior = 'contain';

    const target = event.target as Node | null;
    if (target && scroller.contains(target)) {
      return;
    }
    event.preventDefault();
  }
}
